export default "__VITE_ASSET__vCh5Hsqr__"